var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SF 60x60@2x",
    fill: "#fff",
    stroke: "#eaeaea"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 145",
    d: "M26 20a6 6 0 106 6 6.018 6.018 0 00-6-6z",
    fill: "#ef5323"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "M28.7 27.61c0-1.311-1.047-1.764-1.982-2.04v-2a3.585 3.585 0 01.815.248l.5.249.5-1.009-.506-.249a4.757 4.757 0 00-1.31-.375V21.5h-1.125v.939a2.025 2.025 0 00-1.955 1.95c0 1.3 1.027 1.755 1.955 2.032v2.025a5.754 5.754 0 01-1.38-.293l-.529-.191-.383 1.058.529.191a6.89 6.89 0 001.762.37v.919h1.125v-.932c1.773-.218 1.984-1.415 1.984-1.958zm-3.937-3.221c0-.51.43-.722.83-.808v1.657c-.571-.203-.831-.419-.831-.849zm1.955 4.045v-1.683c.59.2.857.421.857.859-.001.2-.004.675-.858.824z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 146",
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 147",
    d: "M23.766 13l3-5H13.234l3 5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 148",
    d: "M18 26a7.951 7.951 0 019-7.931A35.175 35.175 0 0024.416 15h-8.833C13.416 17.305 10 21.492 10 25c0 2.1.975 7 10 7 .247 0 .465-.017.7-.024A7.977 7.977 0 0118 26z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposits);
export default __webpack_public_path__ + "static/media/deposits.8829d3d3c4c4e78c68a3bd71e5855b9e.svg";
export { ForwardRef as ReactComponent };